import request from '@/utils/request'

//商品列表
export function productList(query) {
  return request({
    url: '/productList',
    method: 'get',
    params: query
  })
}
//用户信息
export function userInfo(query) {
  return request({
    url: '/userInfo',
    method: 'get',
    params: query
  })
}
//修改地址
export function updateAddress(data) {
  return request({
    url: '/addAddressJson',
    method: 'post',
    data: data
  })
}

//获取地址
export function getAddress(query) {
  return request({
    url: '/addressList',
    method: 'get',
    params: query
  })
}
//兑换(2=PC)
export function exchange(propId,num=1) {
  return request({
    url: '/exchange/' + propId + '/' + num + "/2",
    method: 'get'
  })
}
//兑换记录
export function getLogList(query) {
  return request({
    url: '/getLogList',
    method: 'get',
    params: query
  })
}


export function getDownloadList(query) {
  return request({
    url: '/getDownloadList',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/shop.js